<div>
  <!-- [ngClass]="layoutClass" -->
  <a (click)="navigate()">
    <div class="widget col-12" [ngClass]="widgetClass()">
      <ng-container *ngIf="isOK()">
        <div class="col-4">
          <i class="fa fa-5x" [ngClass]="icon"></i>
        </div>
        <div class="col-8 float-right">
          <span> {{ descriptionKey | translate }} </span>
          <h2 class="font-bold">{{ getNumTareas() }}</h2>
        </div>
      </ng-container>
      <ng-container *ngIf="isLoading()">
        <waitLoading></waitLoading>
      </ng-container>
      <ng-container *ngIf="isError()">
        <!-- TODO: Comporbar que el servicio no devuelve datos y mostrar la información -->
        <div class="col-lg-12 alert alert-info ">
          <span class="fa-stack fa-lg">
            <i class="fa fa-circle-o fa-stack-2x" aria-hidden="true"></i>
            <i class="fa fa-info fa-stack-1x" aria-hidden="true"></i>
          </span>
          {{ 'Widget.error' | translate }}
        </div>
      </ng-container>
    </div>
  </a>
</div>